import { System } from "titum-custom/details";
import BizXAutoCare from "./BizXAutoCare";
import { SYSTEM_EDITIONS } from "Components/Constants/SystemEditions";
import { BizXPos } from "./BizXPos";



const DefaultLogo = () => {

    return (
        System.SYSTEM_EDITION == SYSTEM_EDITIONS.BIZ_X_POS && <BizXPos /> ||
        System.SYSTEM_EDITION == SYSTEM_EDITIONS.BIZ_X_AUTO_CARE && <BizXAutoCare />
    );
};

export default DefaultLogo;
